import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { JourneySection } from '../components/JourneySection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-paper text-ink-600 font-sans selection:bg-bronze-400 selection:text-white" data-id="element-259" data-mp="2kyqhudt3xsiq">
      <Navigation data-id="element-260" data-mp="2fzx4cldtm1ik" />
      <main data-id="element-261" data-mp="2fzdxbzppkxjb">
        <HeroSection data-id="element-262" data-mp="2g0yr3n478cg4" />
        <JourneySection data-id="element-263" data-mp="2g0f6fyn5z9ye" />
        <WelcomeSection data-id="element-264" data-mp="qkplbzl15hlt" />
        <OfferingsSection data-id="element-265" data-mp="qk7i2izya34e" />
        <ReviewsSection data-id="element-266" data-mp="qliluitebavi" />
        <AboutSection data-id="element-267" data-mp="qmtnabzdc6jg" />
        <ContactSection data-id="element-268" data-mp="llw5i0i9teih" />
      </main>
      <Footer data-id="element-269" data-mp="lmnzj6w7z46n" />
    </div>;
}